import StyledTableCell from 'Components/StyledTableCell'
import StyledTableRow from 'Components/StyledTableRow'
import TranslatedField from 'Components/TranslatedField'
import type { Zone } from 'Services/ControlDataManagement/Features/Zone/types'
import { datetimeFormatter } from 'Util/formatters'
import { Paper, Table, TableBody, TableCell, TableContainer } from '@mui/material'
import { t } from 'ttag'

interface ZoneDetailsProps {
  zone: Zone
}

export default function ZoneDetails({ zone }: Readonly<ZoneDetailsProps>) {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ td: { border: 'none' } }} aria-label={t`Details table`}>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>{t`Identifier`}</StyledTableCell>
            <TableCell>{zone.id}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Codespace identifier`}</StyledTableCell>
            <TableCell>{zone.codespace_id}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Zone`}</StyledTableCell>
            <TableCell>
              <TranslatedField key="zone" field="value" translations={zone.translations} />
            </TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Created`}</StyledTableCell>
            <TableCell>{datetimeFormatter(zone.created_timestamp)}</TableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell>{t`Modified`}</StyledTableCell>
            <TableCell>{datetimeFormatter(zone.modified_timestamp)}</TableCell>
          </StyledTableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
